import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import NProgress from 'nprogress';

import { Box, GlobalStyles } from '@mui/material';
import { alpha, styled, useTheme } from '@mui/material/styles';
import { IconApp } from '../../assets/icons';

const RootStyle = styled('div')(({ height, sx }) => ({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: height || '100%',
  minHeight: height || 256,
  overflow: 'hidden',
  ...sx
}));

export const ProgressBarStyle = () => {
  const { palette, zIndex } = useTheme();

  return (
    <GlobalStyles
      styles={{
        '#nprogress': {
          pointerEvents: 'none',
          '& .bar': {
            top: 0,
            left: 0,
            height: 2,
            width: '100%',
            position: 'fixed',
            zIndex: zIndex.snackbar,
            backgroundColor: '#ffffff00',
            boxShadow: `0 0 2px ${palette.primary.main}`
          },
          '& .peg': {
            right: 0,
            opacity: 1,
            width: 100,
            display: 'block',
            position: 'absolute',
            transform: 'rotate(3deg) translate(0px, -4px)',
            boxShadow: `0 0 10px ${palette.primary.main}, 0 0 5px ${palette.primary.main}`
          }
        }
      }}
    />
  );
};

const ProgressBar = () => {
  NProgress.configure({
    showSpinner: false
  });

  useEffect(() => {
    NProgress.start();
    return () => {
      NProgress.done();
    };
  }, []);
};

const LoadingScreen = ({ sx, ...other }) => {
  const { palette } = useTheme();

  return (
    <>
      <ProgressBar />

      <RootStyle {...other} sx={sx}>
        <IconApp sx={{ width: 40, height: 40 }} themed />
        <Box
          component={motion.div}
          animate={{
            scale: [1.2, 1, 1, 1.2, 1.2],
            rotate: [270, 0, 0, 270, 270],
            opacity: [0.25, 1, 1, 1, 0.25],
            borderRadius: ['25%', '25%', '50%', '50%', '25%']
          }}
          transition={{ ease: 'linear', duration: 3.2, repeat: Infinity }}
          sx={{
            overflow: 'hidden !important',
            width: 100,
            height: 100,
            borderRadius: '25%',
            position: 'absolute',
            border: `solid 3px ${alpha(palette.primary.dark, 0.24)}`
          }}
        />

        <Box
          component={motion.div}
          animate={{
            scale: [1, 1.2, 1.2, 1, 1],
            rotate: [0, 270, 270, 0, 0],
            opacity: [1, 0.25, 0.25, 0.25, 1],
            borderRadius: ['25%', '25%', '50%', '50%', '25%']
          }}
          transition={{
            ease: 'linear',
            duration: 3.2,
            repeat: Infinity
          }}
          sx={{
            overflow: 'hidden !important',
            width: 120,
            height: 120,
            borderRadius: '25%',
            position: 'absolute',
            border: `solid 8px ${alpha(palette.primary.dark, 0.24)}`
          }}
        />
      </RootStyle>
    </>
  );
};

LoadingScreen.propTypes = {
  sx: PropTypes.object
};

export default LoadingScreen;
